import type { RedirectProps } from 'react-router-dom'
import { Redirect, Route, useLocation } from 'react-router-dom'

interface Props extends RedirectProps {
  code?: number
  from?: string
  to: RedirectProps['to']
  withSearchAndHash?: boolean
}

function getRedirectTo(
  to: RedirectProps['to'],
  location: ReturnType<typeof useLocation>,
  withSearchAndHash: boolean,
): RedirectProps['to'] {
  // When false, the caller has already included search and hash in `to`; use it as-is.
  if (!withSearchAndHash) {
    return to
  }

  if (typeof to === 'string') {
    return {
      pathname: to,
      search: location.search,
      hash: location.hash,
    }
  }

  return {
    ...to,
    search: to.search ?? location.search,
    hash: to.hash ?? location.hash,
  }
}

function RedirectWithStatus(props: Props) {
  const { code, from, withSearchAndHash = true, ...redirectProps } = props
  const location = useLocation()
  const to = getRedirectTo(redirectProps.to, location, withSearchAndHash)

  return <Route
    path={from}
    render={({ staticContext }) => {
      if (staticContext) {
        staticContext.statusCode = code || 302
      }
      return <Redirect
        {...redirectProps}
        to={to}
      />
    }}
  />
}

export default RedirectWithStatus
